import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ComponentProps, PropsWithChildren } from 'react';
export type ViverseCardProps = PropsWithChildren<ComponentProps<typeof Card>> & {};
function ViverseCard(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("cursor-pointer border-0 bg-transparent", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <Card {...props} className={t1}>{children}</Card>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export type ViverseCardHeaderProps = PropsWithChildren<ComponentProps<typeof CardHeader>> & {};
ViverseCard.Header = function ViverseCardHeader({
  children,
  className,
  ...props
}: ViverseCardHeaderProps) {
  return <CardHeader className={cn('mt-[6px] p-0', className)} {...props}>
      {children}
    </CardHeader>;
};
export type ViverseCardContentProps = PropsWithChildren<ComponentProps<typeof CardContent>> & {};
ViverseCard.Content = function ViverseCardContent({
  children,
  className,
  ...props
}: ViverseCardHeaderProps) {
  return <CardContent className={cn('relative overflow-hidden rounded-lg p-0', className)} {...props}>
      {children}
    </CardContent>;
};
export default ViverseCard;